import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-top: 5px;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const SummaryTitle = styled(Typography.Title).attrs({ $variant: '1' })`
  font-size: 16px;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const Label = styled(Typography.Body).attrs({ $variant: '1' })`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body).attrs({ $variant: '1' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const PriceValue = styled(Value)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  font-weight: 500;
`;

export const OriginalPrice = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-weight: 500;
  text-decoration: line-through;
`;

export const Badge = styled.span<{ $appearance: 'promo' | 'promotion' }>`
  padding: 2px 5px;
  border-radius: 16px;
  background: ${({ $appearance, theme }) =>
    $appearance === 'promo'
      ? theme.palette.system.blue
      : 'linear-gradient(90deg, #E56019 0%, #EC7C17 57.21%, #F19216 100%)'};
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 11px;
  font-weight: 700;
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  border: 0;
  margin: 5px 0;
  background-color: ${({ theme }) => theme.palette.primary.border};
`;

export const TotalLabel = styled(Typography.Title).attrs({ $variant: '4' })`
  font-size: 16px;
`;

export const TotalValue = styled(Typography.Numbers).attrs({ $variant: '4' })`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
`;
